import styled, { css } from "styled-components";

const labelStyles = css`
  ${(props) => props.labelStyles}
`;
const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
  padding-right: 40px;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;
export const SectionContainer = styled.section`
  width: 100%;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 1.375rem;
  overflow-y: auto;
`;

export const OuterWrapper = styled.div`
  padding: 0px;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column};
  gap: ${(props) => (props?.gap ? props.gap : "1rem")};
  font-size: 14px;
  color: #ffffff;
  line-height: 1rem;
  border-right: ${(props) => props.borderRight ?? "0px solid #767676"};
  border-left: ${(props) => props.borderLeft ?? "0px solid #767676"};
  border-bottom: ${(props) => props.borderBottom ?? "0px solid #767676"};
  border-top: ${(props) => props.borderTop ?? "0px solid #767676"};
  border-bottom-right-radius: ${(props) => props.borderRadius ?? "0px"};
  border-bottom-left-radius: ${(props) => props.borderRadius ?? "0px"};
  padding: ${(props) => props.padding ?? "0px"};
`;

export const GridItem = styled.div`
  border-right: ${(props) =>
    props.borderRight ?? "0px solid rgba(10, 73, 134, 0.3)"};
  border-left: ${(props) =>
    props.borderLeft ?? "0px solid rgba(10, 73, 134, 0.3)"};
  border-bottom: ${(props) => props.borderBottom ?? "0px solid #767676"};
  line-height: 2rem;
  text-align: ${(props) => props.textAlign ?? "center"};
  color: ${(props) => props.color ?? "#474747"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  background-color: ${(props) => props.backgroundColor ?? "#fff"};
  padding: ${(props) => props.padding ?? "10px"};
  font-size: ${(props) => props.fontSize ?? "16px"};
  border-top-left-radius: ${(props) => props.leftRadius ?? "0px"};
  border-top-right-radius: ${(props) => props.rightRadius ?? "0px"};
  text-decoration: ${(props) => props.textDecoration ?? "none"};
  font-style: ${(props) => props.fontStyle ?? "normal"};
`;

export const MarginDiv = styled.div`
  margin-bottom: 10px;
`;

export const TextInputLabelRequired = styled.label`
  position: relative !important;
  margin-bottom: -8px;
  margin-left: -7px;
  font-family: Lato;
  font-style: normal;
  font-weight: bold;
  font-size: 1rem;
  line-height: 1;
  color: ${(props) => (props.error === "" ? "#1bace4" : "red")};
  position: absolute;
  text-transform: initial;
  left: 0.625rem;
  z-index: 1;
  width: auto;
  transition: transform 150ms ease-out, font-size 150ms ease-out;
  &::after {
    content: "*";
    color: #ea6457;
    font-weight: bold;
  }
`;

export const MarginWrapper = styled.div`
  display: flex;
  -webkit-box-pack: center;
  justify-content: center;
  padding: 12px 0px;
`;

export const CurrencyBanner = styled.div`
  background: #f08046;
  display: flex;
`;

export const ExchangeRateLabel = styled.span`
  display: flex;
  padding: 8px;
  color: ${(props) => props?.color ?? "#fff"};
`;

export const ExchangeRateWrapper = styled.div`
  background: white;
  display: flex;
  justify-content: space-between;
`;

export const ExchangeContainer = styled.div`
  background: #f08046;
  width: 100%;
  padding: 10px 1rem;
`;

export const RequiredMessage = styled.p`
  width: 100%;
  color: red;
  font-size: 0.875rem;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  padding: 0;
  font-weight: 400;
`;

export const ErrorDiv = styled.div`
  height: auto;
  border: solid 1px red;
  padding: 7px;
`;
